module.exports = __webpack_public_path__ + "img/stretch.5462cda7.svg";